export const colors = {
	solid: {
		primary: '#7367F0',
		secondary: '#82868b',
		success: '#28C76F',
		info: '#00cfe8',
		warning: '#FF9F43',
		danger: '#EA5455',
		dark: '#4b4b4b',
		black: '#000',
		white: '#fff',
		body: '#f8f8f8'
	},
	light: {
		primary: '#7367F01a',
		secondary: '#82868b1a',
		success: '#28C76F1a',
		info: '#00cfe81a',
		warning: '#FF9F431a',
		danger: '#EA54551a',
		dark: '#4b4b4b1a'
	}
};
